// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumb{font-size:13px;background:hsla(0,0%,96.9%,.98);color:#999}.breadcrumb .block-inner{margin:0 auto;text-align:left;padding:5px 15px}.breadcrumb .block-inner a{color:inherit}.breadcrumb .block-inner a:after{content:\" / \"}.breadcrumb .block-inner span{color:maroon;font-weight:700}", ""]);
// Exports
module.exports = exports;
